module.exports = __webpack_public_path__ + "img/Vision.9c91ab2e.gif";